import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft, Share2, ChevronDown } from 'lucide-react';
import { Helmet } from 'react-helmet-async';
import { RelatedBlogPosts } from '../../../../components/Blog/RelatedBlogPosts';
import { GoogleTranslateWidget } from '../../../../components/GoogleTranslateWidget';
export function BlogPost7SignsGaslightingID() {
  const articleData = {
    title: '7 Tanda Gaslighting yang Terdeteksi AI Kami Secara Instan',
    description: 'Temukan 7 tanda gaslighting yang terdeteksi AI kami secara instan. Unggah teks Anda untuk mendeteksi manipulasi, penyangkalan, dan pola kekerasan emosional dalam hitungan detik.',
    slug: '7-signs-of-gaslighting',
    publishDate: '2025-01-14',
    author: 'Editorial Toxic Detector'
  };
  const alternateUrls = [{
    lang: 'en',
    url: 'https://toxicdetector.com/blog/7-signs-of-gaslighting'
  }, {
    lang: 'pt-BR',
    url: 'https://toxicdetector.com/pt/blog/7-signs-of-gaslighting'
  }, {
    lang: 'es-MX',
    url: 'https://toxicdetector.com/es/blog/7-signs-of-gaslighting'
  }, {
    lang: 'ja',
    url: 'https://toxicdetector.com/ja/blog/7-signs-of-gaslighting'
  }, {
    lang: 'ko',
    url: 'https://toxicdetector.com/ko/blog/7-signs-of-gaslighting'
  }, {
    lang: 'de',
    url: 'https://toxicdetector.com/de/blog/7-signs-of-gaslighting'
  }, {
    lang: 'fr',
    url: 'https://toxicdetector.com/fr/blog/7-signs-of-gaslighting'
  }, {
    lang: 'hi',
    url: 'https://toxicdetector.com/hi/blog/7-signs-of-gaslighting'
  }, {
    lang: 'id',
    url: 'https://toxicdetector.com/id/blog/7-signs-of-gaslighting'
  }];
  const handleShare = async () => {
    try {
      await navigator.share({
        title: articleData.title,
        text: articleData.description,
        url: window.location.href
      });
    } catch (err) {
      navigator.clipboard.writeText(window.location.href);
      alert('Tautan disalin ke papan klip!');
    }
  };
  const faqSchema = {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: [{
      '@type': 'Question',
      name: 'Apa tanda-tanda awal gaslighting dalam suatu hubungan?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: 'Tanda-tanda awal termasuk penyangkalan peristiwa, memutarbalikkan fakta, meminimalkan perasaan Anda, dan menyalahkan. Pola-pola ini secara bertahap membuat Anda meragukan persepsi Anda sendiri.'
      }
    }, {
      '@type': 'Question',
      name: 'Bisakah gaslighting benar-benar terjadi melalui pesan teks?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: 'Ya. Gaslighting melalui teks sangat umum. Pesan bisa manipulatif, mendistorsi fakta, atau membuat rasa bersalah. AI kami mendeteksi pola-pola ini secara instan dari riwayat obrolan Anda.'
      }
    }, {
      '@type': 'Question',
      name: 'Bagaimana AI Toxic Detector mengidentifikasi pola gaslighting?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: 'Toxic Detector menganalisis perubahan nada, kontradiksi, pola menyalahkan, minimisasi emosional, bahasa yang memicu rasa bersalah, dan perbedaan perilaku publik vs pribadi.'
      }
    }, {
      '@type': 'Question',
      name: 'Apa perbedaan antara gaslighting dan ketidaksepakatan normal?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: 'Ketidaksepakatan normal melibatkan dua perspektif. Gaslighting melibatkan upaya yang disengaja atau berulang untuk mendistorsi realitas Anda, membatalkan emosi Anda, atau membuat Anda mempertanyakan kewarasan Anda.'
      }
    }, {
      '@type': 'Question',
      name: 'Mengapa orang melakukan gaslighting dalam hubungan?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: 'Gaslighter sering menginginkan kontrol, menghindari tanggung jawab, atau memanipulasi emosi pasangannya. Banyak yang mengulangi pola yang dipelajari tanpa menyadari kerusakannya.'
      }
    }, {
      '@type': 'Question',
      name: 'Bisakah gaslighting tidak disengaja?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: 'Ya, beberapa orang melakukan gaslighting tanpa menyadarinya. Perilaku tersebut mungkin berasal dari rasa tidak aman, penghindaran, atau kebiasaan komunikasi beracun yang dipelajari.'
      }
    }, {
      '@type': 'Question',
      name: 'Apa yang harus saya lakukan jika saya pikir pasangan saya melakukan gaslighting?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: 'Percayai insting Anda, dokumentasikan percakapan, bicaralah dengan seseorang yang Anda percayai, dan pertimbangkan untuk mendapatkan perspektif profesional. Alat seperti Toxic Detector dapat membantu mengonfirmasi pola.'
      }
    }, {
      '@type': 'Question',
      name: 'Apakah gaslighting merupakan bentuk kekerasan emosional?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: 'Ya. Gaslighting diakui sebagai bentuk kekerasan psikologis dan emosional karena memanipulasi persepsi seseorang tentang realitas.'
      }
    }, {
      '@type': 'Question',
      name: 'Seberapa akurat Toxic Detector dalam mendeteksi manipulasi?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: 'AI kami menganalisis pola linguistik, nada, dan perilaku dalam pesan Anda dengan akurasi tinggi. Ini memberikan laporan yang jelas dan dapat dibagikan yang didukung oleh analisis perilaku yang konsisten.'
      }
    }, {
      '@type': 'Question',
      name: 'Apakah gaslighting memburuk seiring waktu?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: 'Gaslighting sering meningkat secara bertahap. Saat korban menjadi lebih bingung atau bergantung, manipulator meningkatkan kontrol dan mengintensifkan tekanan emosional.'
      }
    }]
  };
  const articleSchema = {
    '@context': 'https://schema.org',
    '@type': 'Article',
    headline: articleData.title,
    description: articleData.description,
    image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/89an98a4aCmEYGiFGxbV6q/1763120076017.jpg',
    datePublished: articleData.publishDate,
    author: {
      '@type': 'Organization',
      name: articleData.author
    },
    publisher: {
      '@type': 'Organization',
      name: 'ToxicDetector',
      logo: {
        '@type': 'ImageObject',
        url: 'https://toxicdetector.com/images/logo.png'
      }
    }
  };
  return <div className="min-h-screen bg-gray-50" data-id="element-6376" data-mp="brno72yf7pev">
      <GoogleTranslateWidget data-id="element-6377" data-mp="bsyogssnqf18" />
      <Helmet data-id="element-6378" data-mp="bpja5s6t5a0v">
        <title data-id="element-6379" data-mp="6sjdg7vuljmf">
          7 Tanda Gaslighting (Terdeteksi AI) — Hentikan Manipulasi |
          ToxicDetector
        </title>
        <meta name="description" content="Pikir seseorang melakukan gaslighting pada Anda? AI kami mengungkapkan 7 tanda teratas secara instan dengan menganalisis obrolan Anda." data-id="element-6380" data-mp="2qfruqfgsynf" />
        <meta name="keywords" content="tanda gaslighting, contoh gaslighting, gaslighting dalam pesan teks, perilaku manipulatif, detektor gaslighting AI" data-id="element-6381" data-mp="2if4ojqw76dr0" />
        <meta name="language" content="id" data-id="element-6382" data-mp="2selu88bg8rmz" />
        <link rel="canonical" href="https://toxicdetector.com/id/blog/7-signs-of-gaslighting" data-id="element-6383" data-mp="2sdasee1kdtyi" />
        {alternateUrls.map(alternate => <link key={alternate.lang} rel="alternate" hrefLang={alternate.lang} href={alternate.url} data-id="element-6384" data-mp="1zqg9vmob54no" />)}
        <meta property="og:type" content="article" data-id="element-6385" data-mp="29ey6drpk0pli" />
        <meta property="og:title" content="7 Tanda Gaslighting yang Terdeteksi AI Kami Secara Instan" data-id="element-6386" data-mp="29gsrb60tshpl" />
        <meta property="og:description" content="Pikir seseorang melakukan gaslighting pada Anda? AI kami mengungkapkan 7 tanda teratas secara instan dengan menganalisis obrolan Anda." data-id="element-6387" data-mp="1bxzob25d2ujm" />
        <meta property="og:url" content="https://toxicdetector.com/id/blog/7-signs-of-gaslighting" data-id="element-6388" data-mp="5crpdk6oswuq" />
        <meta property="og:image" content="https://cdn.magicpatterns.com/uploads/9AgsYP8bczHQvssTJAPniL/file_00000000842c7243a7657dadb3d089c4.png" data-id="element-6389" data-mp="jdc5u9p4qgl2" />
        <meta property="og:locale" content="id_ID" data-id="element-6390" data-mp="t9xcezgsrzr0" />
        <meta name="twitter:card" content="summary_large_image" data-id="element-6391" data-mp="t8mcxbudxe5p" />
        <meta name="twitter:title" content="7 Tanda Gaslighting (Terdeteksi AI)" data-id="element-6392" data-mp="oab1wxscsxlw" />
        <meta name="twitter:description" content="AI kami mengungkapkan 7 tanda teratas gaslighting secara instan dengan menganalisis obrolan Anda." data-id="element-6393" data-mp="121h8fdu1vvia" />
        <meta name="twitter:image" content="https://uploadthingy.s3.us-west-1.amazonaws.com/89an98a4aCmEYGiFGxbV6q/1763120076017.jpg" data-id="element-6394" data-mp="1c05ede8rgk5m" />
        <script type="application/ld+json" data-id="element-6395" data-mp="1qnnkmh1z1mu5">
          {JSON.stringify(articleSchema)}
        </script>
        <script type="application/ld+json" data-id="element-6396" data-mp="1vmqcezsxxwk6">{JSON.stringify(faqSchema)}</script>
      </Helmet>

      <div className="flex flex-col w-full min-h-screen bg-gradient-to-b from-stone-50 to-white" data-id="element-6397" data-mp="1gphji1nzokqc">
        <header className="bg-white/90 border-b border-gray-200 sticky top-0 z-50 backdrop-blur-sm" data-id="element-6398" data-mp="1lokdmr2fl6jj">
          <div className="max-w-3xl mx-auto px-6 py-4" data-id="element-6399" data-mp="17x5tui0p91bf">
            <div className="flex items-center justify-between" data-id="element-6400" data-mp="17vkzotiarke3">
              <Link to="/" className="text-2xl font-bold tracking-tight text-gray-900" data-id="element-6401" data-mp="1coe5zltez0sa">
                🚩 ToxicDetector
              </Link>
              <button onClick={handleShare} className="p-2.5 hover:bg-gray-50 rounded-lg transition-colors" aria-label="Bagikan artikel" data-id="element-6402" data-mp="12xt6lw5x1s8b">
                <Share2 size={20} className="text-gray-600" data-id="element-6403" data-mp="t0es423jzdin" />
              </button>
            </div>
          </div>
        </header>

        <article className="max-w-3xl mx-auto w-full px-6 py-12" data-id="element-6404" data-mp="9vt6mw7vqf3b">
          <Link to="/blog" className="inline-flex items-center text-gray-600 text-sm mb-10 hover:text-gray-900 transition-colors group" data-id="element-6405" data-mp="ew73di4162m1">
            <ArrowLeft size={16} className="mr-2 group-hover:-translate-x-1 transition-transform" data-id="element-6406" data-mp="y931gmjo6pj" />
            Kembali ke Blog
          </Link>

          <header className="mb-12" data-id="element-6407" data-mp="sp5eqdwvc5b8">
            <h1 className="text-4xl md:text-5xl font-bold mb-6 tracking-tight leading-tight text-gray-900" data-id="element-6408" data-mp="xmos7blqse24">
              {articleData.title}
            </h1>
            <div className="flex items-center text-gray-600 text-sm gap-3" data-id="element-6409" data-mp="jso2t8gok3ef">
              <time dateTime={articleData.publishDate} data-id="element-6410" data-mp="nv14nlsb3h5x">
                {new Date(articleData.publishDate).toLocaleDateString('id-ID', {
                year: 'numeric',
                month: 'long',
                day: 'numeric'
              })}
              </time>
              <span className="text-gray-300" data-id="element-6411" data-mp="3120hwtgfwc9v">•</span>
              <span data-id="element-6412" data-mp="310pgh0agvglx">{articleData.author}</span>
            </div>
          </header>

          <div className="mb-12" data-id="element-6413" data-mp="2w3pasqhj4fvc">
            <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/89an98a4aCmEYGiFGxbV6q/1763120076017.jpg" alt="AI mendeteksi tanda-tanda gaslighting dalam teks hubungan" className="w-full rounded-2xl shadow-sm border border-gray-200" data-id="element-6414" data-mp="3aslop469on3v" />
          </div>

          <div className="bg-white rounded-xl p-6 border border-gray-200 mb-12" data-id="element-6415" data-mp="2d5mseujhlh6i">
            <h2 className="font-bold text-lg mb-4 text-gray-900" data-id="element-6416" data-mp="2s2409bsgwdob">Daftar Isi</h2>
            <ul className="space-y-3 text-sm" data-id="element-6417" data-mp="2s010i01ij66e">
              <li data-id="element-6418" data-mp="2n299d88ozo39">
                <a href="#denying" className="text-gray-600 hover:text-gray-900 transition-colors flex items-center gap-2" data-id="element-6419" data-mp="2n1pqnpb7wvo6">
                  <span className="text-gray-400" data-id="element-6420" data-mp="2c0cleic9dwj">→</span> 1. Menyangkal Apa
                  yang Terjadi
                </a>
              </li>
              <li data-id="element-6421" data-mp="9ick3ii4mw0m">
                <a href="#twisting" className="text-gray-600 hover:text-gray-900 transition-colors flex items-center gap-2" data-id="element-6422" data-mp="efcq5tez7yrq">
                  <span className="text-gray-400" data-id="element-6423" data-mp="jccvu37wyzib">→</span> 2. Memutarbalikkan
                  Fakta
                </a>
              </li>
              <li data-id="element-6424" data-mp="3mvob3s64iurs">
                <a href="#trivializing" className="text-gray-600 hover:text-gray-900 transition-colors flex items-center gap-2" data-id="element-6425" data-mp="3mw7joi9vw6t5">
                  <span className="text-gray-400" data-id="element-6426" data-mp="nofzvoafkde">→</span> 3. Meremehkan
                  Perasaan Anda
                </a>
              </li>
              <li data-id="element-6427" data-mp="5fzfixf4945f">
                <a href="#shifting" className="text-gray-600 hover:text-gray-900 transition-colors flex items-center gap-2" data-id="element-6428" data-mp="5ghmop3bh2s4">
                  <span className="text-gray-400" data-id="element-6429" data-mp="391x3wqfv7mz8">→</span> 4. Mengalihkan
                  Kesalahan
                </a>
              </li>
              <li data-id="element-6430" data-mp="1m7bdluadsbxy">
                <a href="#victim" className="text-gray-600 hover:text-gray-900 transition-colors flex items-center gap-2" data-id="element-6431" data-mp="1m6s85d1x3g0t">
                  <span className="text-gray-400" data-id="element-6432" data-mp="1c94aae90lsef">→</span> 5. Bermain Korban
                </a>
              </li>
              <li data-id="element-6433" data-mp="17aaycq9dm9gd">
                <a href="#overtime" className="text-gray-600 hover:text-gray-900 transition-colors flex items-center gap-2" data-id="element-6434" data-mp="17asyhxz5t7tk">
                  <span className="text-gray-400" data-id="element-6435" data-mp="ygxvavhllrgk">→</span> 6. Gaslighting
                  Seiring Waktu
                </a>
              </li>
              <li data-id="element-6436" data-mp="tk7g0admazw7">
                <a href="#tone" className="text-gray-600 hover:text-gray-900 transition-colors flex items-center gap-2" data-id="element-6437" data-mp="tgjkj5om43eu">
                  <span className="text-gray-400" data-id="element-6438" data-mp="jkqbhwa3qs1t">→</span> 7. Perubahan Nada
                  Publik vs Pribadi
                </a>
              </li>
              <li data-id="element-6439" data-mp="2ol9i7yyeu38h">
                <a href="#faq" className="text-gray-600 hover:text-gray-900 transition-colors flex items-center gap-2" data-id="element-6440" data-mp="2olsscthtjnby">
                  <span className="text-gray-400" data-id="element-6441" data-mp="2evg70z26jq4r">→</span> Pertanyaan yang
                  Sering Diajukan
                </a>
              </li>
            </ul>
          </div>

          <div className="prose prose-lg max-w-none" data-id="element-6442" data-mp="20yb4va5l7bes">
            <p className="text-xl mb-8 leading-relaxed text-gray-700" data-id="element-6443" data-mp="25w2t9u70wfe8">
              Pernah merasa seperti Anda kehilangan akal dalam suatu hubungan?
              🚩 Mungkin pasangan Anda mengatakan satu hal, tetapi naluri Anda
              mengatakan hal lain. Itu disebut <strong data-id="element-6444" data-mp="3lc1ns2npwcw0">gaslighting</strong>,
              perilaku manipulatif halus yang dirancang untuk membuat Anda
              meragukan diri sendiri.
            </p>
            <p className="mb-12 text-lg leading-relaxed text-gray-600" data-id="element-6445" data-mp="3q8sedjx5eqvo">
              Kebanyakan orang melewatkan tanda-tanda gaslighting, tetapi AI
              kami mendeteksinya secara instan dengan menganalisis obrolan Anda
              untuk mengungkapkan kebenaran. Berikut adalah 7 tanda gaslighting
              yang ditangkap AI kami sehingga Anda tidak perlu melakukannya.
            </p>

            <section id="denying" className="mb-12" data-id="element-6446" data-mp="1jkjeja2nlknz">
              <h2 className="text-3xl font-bold mb-6 tracking-tight text-gray-900" data-id="element-6447" data-mp="1xczlun2l84up">
                1️⃣ Menyangkal Apa yang Terjadi
              </h2>
              <div className="bg-gray-50 border-l-4 border-purple-600 p-6 mb-6 rounded-r-xl" data-id="element-6448" data-mp="1tes2dkgqopft">
                <p className="italic text-gray-700 text-lg" data-id="element-6449" data-mp="279uif0favv6c">
                  "Aku tidak pernah mengatakan itu."
                </p>
              </div>
              <p className="text-lg leading-relaxed text-gray-600" data-id="element-6450" data-mp="cz8o4ofssytf">
                Terdengar akrab? Gaslighter sering menyangkal fakta atau
                peristiwa untuk membingungkan Anda. AI mendeteksi kontradiksi
                berulang dan menandai pesan yang mencoba menghapus kenyataan.
              </p>
            </section>

            <section id="twisting" className="mb-12" data-id="element-6451" data-mp="2d2jd2rmve7zd">
              <h2 className="text-3xl font-bold mb-6 tracking-tight text-gray-900" data-id="element-6452" data-mp="2h1r0qkreo49x">
                2️⃣ Memutarbalikkan Fakta
              </h2>
              <div className="bg-gray-50 border-l-4 border-purple-600 p-6 mb-6 rounded-r-xl" data-id="element-6453" data-mp="2lz0qy2mmcjyt">
                <p className="italic text-gray-700 text-lg" data-id="element-6454" data-mp="2qy3vzn2lmq6s">
                  "Kamu hanya membayangkan sesuatu."
                </p>
              </div>
              <p className="text-lg leading-relaxed text-gray-600" data-id="element-6455" data-mp="30prirao7nj1x">
                Langkah klasik ini membuat Anda mempertanyakan ingatan Anda. AI
                menandai ketika pesan dimanipulasi atau dibingkai ulang secara
                selektif untuk membuat Anda ragu.
              </p>
            </section>

            <section id="trivializing" className="mb-12" data-id="element-6456" data-mp="3eqkdnwifcg5k">
              <h2 className="text-3xl font-bold mb-6 tracking-tight text-gray-900" data-id="element-6457" data-mp="3otfyz09laebi">
                3️⃣ Meremehkan Perasaan Anda
              </h2>
              <div className="bg-gray-50 border-l-4 border-purple-600 p-6 mb-6 rounded-r-xl" data-id="element-6458" data-mp="3jt1olbkimsab">
                <p className="italic text-gray-700 text-lg" data-id="element-6459" data-mp="3ewbagts9u6rj">
                  "Kamu terlalu sensitif."
                </p>
              </div>
              <p className="text-lg leading-relaxed text-gray-600" data-id="element-6460" data-mp="betebjlv2o6y">
                Meminimalkan emosi Anda adalah tanda bahaya besar. AI mendeteksi
                pola nada yang menolak atau merendahkan perasaan Anda.
              </p>
            </section>

            <section id="shifting" className="mb-12" data-id="element-6461" data-mp="1nglops8ntzv">
              <h2 className="text-3xl font-bold mb-6 tracking-tight text-gray-900" data-id="element-6462" data-mp="3tt2ejgcw46nh">
                4️⃣ Mengalihkan Kesalahan
              </h2>
              <div className="bg-gray-50 border-l-4 border-purple-600 p-6 mb-6 rounded-r-xl" data-id="element-6463" data-mp="u6vlm4cm4s4j">
                <p className="italic text-gray-700 text-lg" data-id="element-6464" data-mp="pd16le7yd1bs">"Ini salahmu."</p>
              </div>
              <p className="text-lg leading-relaxed text-gray-600" data-id="element-6465" data-mp="191ussye7xpqz">
                Pernah memperhatikan bagaimana argumen selalu berakhir menjadi
                "salahmu"? AI menyoroti upaya berulang untuk mengalihkan
                tanggung jawab, sehingga Anda dapat melihat polanya dengan
                jelas.
              </p>
            </section>

            <section id="victim" className="mb-12" data-id="element-6466" data-mp="1rtdtgykrsrpu">
              <h2 className="text-3xl font-bold mb-6 tracking-tight text-gray-900" data-id="element-6467" data-mp="1rtvwce1xu46q">
                5️⃣ Bermain Korban
              </h2>
              <div className="bg-gray-50 border-l-4 border-purple-600 p-6 mb-6 rounded-r-xl" data-id="element-6468" data-mp="1hv6pdgbky459">
                <p className="italic text-gray-700 text-lg" data-id="element-6469" data-mp="1mu1529e93cl5">
                  "Setelah semua yang aku lakukan untukmu..."
                </p>
              </div>
              <p className="text-lg leading-relaxed text-gray-600" data-id="element-6470" data-mp="6e83jxjnfswr">
                Membuat rasa bersalah adalah bentuk kontrol yang halus. AI
                menandai frasa manipulatif yang dirancang untuk membuat Anda
                merasa buruk atau meminta maaf secara berlebihan.
              </p>
            </section>

            <section id="overtime" className="mb-12" data-id="element-6471" data-mp="2kpwoszz5nj2b">
              <h2 className="text-3xl font-bold mb-6 tracking-tight text-gray-900" data-id="element-6472" data-mp="2ym0i8r27fndq">
                6️⃣ Gaslighting Seiring Waktu ⏳
              </h2>
              <p className="text-lg leading-relaxed text-gray-600" data-id="element-6473" data-mp="26w5hly8wcb9r">
                Gaslighting tidak selalu jelas. Itu dibangun secara bertahap. AI
                melacak pola di berbagai percakapan, memberi Anda pandangan
                menyeluruh tentang perilaku beracun.
              </p>
            </section>

            <section id="tone" className="mb-12" data-id="element-6474" data-mp="2ax7iskmdixed">
              <h2 className="text-3xl font-bold mb-6 tracking-tight text-gray-900" data-id="element-6475" data-mp="2awfyi5y88m3e">
                7️⃣ Perubahan Nada Publik vs Pribadi
              </h2>
              <div className="bg-gray-50 border-l-4 border-purple-600 p-6 mb-6 rounded-r-xl" data-id="element-6476" data-mp="1j7ctgnyin7pp">
                <p className="italic text-gray-700 text-lg" data-id="element-6477" data-mp="d7vn6282glwp">
                  Grup chat: 😊 / 1:1: 😡
                </p>
              </div>
              <p className="text-lg leading-relaxed text-gray-600" data-id="element-6478" data-mp="98mwx7c8j65w">
                Beberapa gaslighter berperilaku berbeda di depan umum
                dibandingkan pesan pribadi. AI menangkap perbedaan dan menyoroti
                perubahan suasana hati yang tiba-tiba atau agresi tersembunyi.
              </p>
            </section>

            <section className="mb-12" data-id="element-6479" data-mp="rxjsdejdc4pp">
              <h2 className="text-3xl font-bold mb-6 tracking-tight text-gray-900" data-id="element-6480" data-mp="rwi3a65iphoz">
                🛡 Cara Melindungi Diri Sendiri
              </h2>
              <div className="bg-white rounded-xl border border-gray-200 p-6" data-id="element-6481" data-mp="10xye2f08vltq">
                <ul className="space-y-3 text-lg text-gray-600" data-id="element-6482" data-mp="10vveb39aiebt">
                  <li className="flex items-start gap-3" data-id="element-6483" data-mp="37p7ai3tq3sog">
                    <span className="text-purple-600 font-bold" data-id="element-6484" data-mp="32pkx9udwacfn">•</span>
                    <span data-id="element-6485" data-mp="32rfmhkw78qpj">Percayai insting Anda.</span>
                  </li>
                  <li className="flex items-start gap-3" data-id="element-6486" data-mp="1i7tzxtl67ux9">
                    <span className="text-purple-600 font-bold" data-id="element-6487" data-mp="1n6wtagrsgcpe">•</span>
                    <span data-id="element-6488" data-mp="1n87vic5l5cee">Simpan catatan percakapan.</span>
                  </li>
                  <li className="flex items-start gap-3" data-id="element-6489" data-mp="19eqfv2g0sjtn">
                    <span className="text-purple-600 font-bold" data-id="element-6490" data-mp="1dfshfpxet7ys">•</span>
                    <span data-id="element-6491" data-mp="zh2gu0bdsq5o">Bicaralah dengan teman atau terapis.</span>
                  </li>
                  <li className="flex items-start gap-3" data-id="element-6492" data-mp="14fvv3uyhsl6w">
                    <span className="text-purple-600 font-bold" data-id="element-6493" data-mp="14hgrlq4dae7e">•</span>
                    <span data-id="element-6494" data-mp="qgw9yxa6uofh">
                      Yang paling penting: jangan abaikan tanda bahaya.
                    </span>
                  </li>
                </ul>
              </div>
            </section>

            <section className="mb-12" data-id="element-6495" data-mp="2kv6xn2f1rcjo">
              <h2 className="text-3xl font-bold mb-6 tracking-tight text-gray-900" data-id="element-6496" data-mp="2ks1a3rm2giq2">
                💀 Mengapa AI Kami Berhasil
              </h2>
              <p className="mb-6 text-lg leading-relaxed text-gray-600" data-id="element-6497" data-mp="1njla4mtvqa0">
                Tidak seperti manusia atau chatbot umum, Toxic Detector
                memberikan:
              </p>
              <div className="bg-white rounded-xl border border-gray-200 p-6 mb-6" data-id="element-6498" data-mp="3orhg7b96ir41">
                <ul className="space-y-3 text-lg text-gray-600" data-id="element-6499" data-mp="3jt64sw38k8jp">
                  <li className="flex items-start gap-3" data-id="element-6500" data-mp="3juzc8dloawsr">
                    <span className="text-purple-600 font-bold" data-id="element-6501" data-mp="kcpxd8t49jmu">•</span>
                    <span data-id="element-6502" data-mp="gcfui50mf9c7">Unggah tangkapan layar satu ketukan</span>
                  </li>
                  <li className="flex items-start gap-3" data-id="element-6503" data-mp="blh8qpwv5j1k">
                    <span className="text-purple-600 font-bold" data-id="element-6504" data-mp="bjwgx81xoe7e">•</span>
                    <span data-id="element-6505" data-mp="6n5xqbuu12hr">Hasil instan yang dapat dibagikan</span>
                  </li>
                  <li className="flex items-start gap-3" data-id="element-6506" data-mp="142a6kkd48tve">
                    <span className="text-purple-600 font-bold" data-id="element-6507" data-mp="143uzy6np26ro">•</span>
                    <span data-id="element-6508" data-mp="z9gzvqy37bgo">
                      Hasil emosional dan dapat dipercaya yang benar-benar dapat
                      Anda andalkan
                    </span>
                  </li>
                </ul>
              </div>
              <p className="text-lg font-semibold text-gray-900" data-id="element-6509" data-mp="1bn48xysag3g7">
                Berhenti bertanya-tanya. Mulai mengetahui. 💖
              </p>
            </section>

            <section id="faq" className="mb-12" data-id="element-6510" data-mp="1knixd70jtynx">
              <h2 className="text-3xl font-bold mb-8 tracking-tight text-gray-900" data-id="element-6511" data-mp="1plc01q2n8ajg">
                Pertanyaan yang Sering Diajukan
              </h2>
              <div className="space-y-4" data-id="element-6512" data-mp="1uikmi2utr0qi">
                {faqSchema.mainEntity.map((faq, index) => <details key={index} className="bg-white rounded-xl border border-gray-200 overflow-hidden group" data-id="element-6513" data-mp="1zbnh8ebc8g8a" data-mpi={index}>
                    <summary className="px-6 py-4 cursor-pointer font-semibold text-base text-gray-900 hover:bg-gray-50 transition-colors flex items-center justify-between" data-id="element-6514" data-mp="28clf0ev6nrif">
                      <span data-id="element-6515" data-mp="1zneb6ayxfkw6">{faq.name}</span>
                      <ChevronDown size={20} className="text-gray-400 group-open:rotate-180 transition-transform" data-id="element-6516" data-mp="1zm3a4iwv8r8r" />
                    </summary>
                    <div className="px-6 pb-4 text-gray-600 leading-relaxed text-sm" data-id="element-6517" data-mp="29ftsd62eg5g0">
                      {faq.acceptedAnswer.text}
                    </div>
                  </details>)}
              </div>
            </section>
          </div>

          <div className="bg-purple-600 rounded-2xl p-10 text-center text-white mt-16" data-id="element-6518" data-mp="1coi3pibph1cv">
            <h2 className="text-3xl font-bold mb-4 tracking-tight" data-id="element-6519" data-mp="1qnhscpz7xg91">
              💀 Siap Melihat Kebenaran?
            </h2>
            <p className="text-purple-100 mb-8 text-lg leading-relaxed max-w-2xl mx-auto" data-id="element-6520" data-mp="1lmk4bwrj1rzm">
              Gaslighting itu halus, berbahaya, dan melelahkan, tetapi AI kami
              dapat membuatnya sangat jelas. Unggah obrolan Anda dan dapatkan
              laporan toksisitas instan Anda.
            </p>
            <div className="bg-white/10 backdrop-blur-sm rounded-xl p-6 mb-8 border border-white/20" data-id="element-6521" data-mp="iu7tq481gt1o">
              <p className="font-bold text-xl" data-id="element-6522" data-mp="nsj2scqieziu">
                "🚩 83% beracun. Waspadalah terhadap manipulasi!"
              </p>
            </div>
            <Link to="/signup" className="inline-block bg-white text-purple-600 px-10 py-4 rounded-lg font-bold text-lg hover:bg-gray-50 transition-colors" data-id="element-6523" data-mp="et5s5gqng4wj">
              Pindai Obrolan Anda Sekarang →
            </Link>
          </div>

          <RelatedBlogPosts posts={[{
          title: 'Pelajari Tentang Istilah: Narsisme & Gaslighting',
          description: 'Pahami psikologi di balik taktik manipulasi narsisme dan gaslighting.',
          slug: 'narcissism-gaslighting-explained',
          emoji: '💀'
        }, {
          title: 'Apakah Mantan Anda Narsisis Terselubung?',
          description: 'Temukan jika mantan Anda menunjukkan tanda-tanda perilaku narsisis terselubung melalui analisis teks.',
          slug: 'is-your-ex-a-covert-narcissist',
          emoji: '🎭'
        }]} data-id="element-6524" data-mp="styp084fbc2t" />

          <div className="mt-12 text-center" data-id="element-6525" data-mp="1l6sggbk5dij4">
            <button onClick={handleShare} className="inline-flex items-center text-gray-600 hover:text-gray-900 font-medium transition-colors text-sm" data-id="element-6526" data-mp="1l9wvk3z5hyok">
              <Share2 size={18} className="mr-2" data-id="element-6527" data-mp="1cdfeyl80p8lf" />
              Bagikan artikel ini
            </button>
          </div>
        </article>

        <footer className="bg-white border-t border-gray-200 py-12 mt-16" data-id="element-6528" data-mp="12huj74tjl4k4">
          <div className="max-w-3xl mx-auto px-6 text-center" data-id="element-6529" data-mp="12fhv09x6xxym">
            <p className="text-gray-500 text-sm" data-id="element-6530" data-mp="xhq33fwjqbuf">
              © {new Date().getFullYear()} ToxicDetector. Hak cipta dilindungi
              undang-undang.
            </p>
          </div>
        </footer>
      </div>
    </div>;
}